import styled from 'styled-components'

export const StyledSectionNavigation = styled.div`

  .nav-title {
    font-weight: 600;
    font-size: 14px;
    color: ${props => props.theme.firstColor};
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0e0e0;
  }

  .nav-items {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .nav-item {
    display: flex;
    align-items: baseline;
    gap: 6px;
    padding: 8px 14px;
    background-color: #f7f7f7;
    border: 1px solid #d4d4d4;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 13px !important;
    max-height: 38px !important;

    i.icon {
      margin: 0;
      color: ${props => props.theme.firstColor};
      font-size: 14px;
    }

    &:hover {
      background-color: ${props => props.theme.firstColor};
      border-color: ${props => props.theme.firstColor};
      color: #fff;

      i.icon {
        color: #fff;
      }
    }

    span {
      white-space: nowrap;
    }
  }
`
